<template>
  <div class="img-wrap">
    <div v-for="(item, index) in imgList" :key="index">
      <el-image
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="imgList"
      >
      </el-image>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
  },
  watch: {
    value() {
      let photos = '';
      console.log(this.value);
      photos = this.value[0].photos;
      this.imgList = photos.split(',');
      // const temp = [];
      // for (const item of this.value) {
      //   if (item.photos.indexOf(',') !== -1) {
      //     const photos = item.photos.split(',');
      //     temp.push(photos);
      //   } else {
      //     temp.push(item.photos);
      //   }
      // }
      this.imgList = temp;
    },
  },
  data() {
    return {
      imgList: [], // 当前关联费用科目数据
    };
  },

  methods: {},
};
</script>
<style scoped>
.img-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
</style>
